import * as actions from "./actionTypes";

export function saveSelection(params) {
    return {
        type: actions.SAVE_SELECTION,
        payload: params,
    }
}
